import { defineMessages } from 'react-intl-next';

export const messages: {
	cancelDeleteButtonText: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	confirmDeleteButtonText: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	invokeDeleteButtonText: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	modalDescriptionText: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	modalHeaderText: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	invokeDeleteButtonText: {
		id: 'company-hub.links-menu-extension.config-panel.item-dropdown.delete-item-button.text',
		defaultMessage: 'Delete item',
		description: 'Text for the delete item button in the item dropdown',
	},
	modalHeaderText: {
		id: 'company-hub.links-menu-extension.config-panel.delete-nested-items-modal.title-text',
		defaultMessage: 'Delete item',
		description: 'Header text for the delete item confirmation modal',
	},
	modalDescriptionText: {
		id: 'company-hub.links-menu-extension.config-panel.delete-nested-items-modal.description-text',
		defaultMessage: 'This action will delete this item and all nested items.',
		description:
			'Modal description of what will happen if user confirms delete of the current item with nested items',
	},
	confirmDeleteButtonText: {
		id: 'company-hub.links-menu-extension.config-panel.delete-nested-items-modal.confirm-text',
		defaultMessage: 'Delete',
		description:
			'Button text for user to confirm delete of item and nested items in a confirmation modal',
	},
	cancelDeleteButtonText: {
		id: 'company-hub.links-menu-extension.config-panel.delete-nested-items-modal.cancel-text',
		defaultMessage: 'Cancel',
		description:
			'Button text for user to cancel delete of item and nested items in a confirmation modal',
	},
});
